export const getAbbreviatedState = (fullStateName) => {
  switch (fullStateName && fullStateName.toLowerCase()) {
    case 'alabama':
      return 'al';
    case 'alaska':
      return 'ak';
    case 'arizona':
      return 'az';
    case 'arkansas':
      return 'ar';
    case 'california':
      return 'ca';
    case 'colorado':
      return 'co';
    case 'connecticut':
      return 'ct';
    case 'delaware':
      return 'de';
    case 'florida':
      return 'fl';
    case 'georgia':
      return 'ga';
    case 'hawaii':
      return 'hi';
    case 'idaho':
      return 'id';
    case 'illinois':
      return 'il';
    case 'indiana':
      return 'in';
    case 'iowa':
      return 'ia';
    case 'kansas':
      return 'ks';
    case 'kentucky':
      return 'ky';
    case 'louisiana':
      return 'la';
    case 'maine':
      return 'me';
    case 'maryland':
      return 'md';
    case 'massachusetts':
      return 'ma';
    case 'michigan':
      return 'mi';
    case 'minnesota':
      return 'mn';
    case 'mississippi':
      return 'ms';
    case 'missouri':
      return 'mo';
    case 'montana':
      return 'mt';
    case 'nebraska':
      return 'ne';
    case 'nevada':
      return 'nv';
    case 'new-hampshire':
      return 'nh';
    case 'new-jersey':
      return 'nj';
    case 'new-mexico':
      return 'nm';
    case 'new-york':
      return 'ny';
    case 'north-carolina':
      return 'nc';
    case 'north-dakota':
      return 'nd';
    case 'ohio':
      return 'oh';
    case 'oklahoma':
      return 'ok';
    case 'oregon':
      return 'or';
    case 'pennsylvania':
      return 'pa';
    case 'rhode-island':
      return 'ri';
    case 'south-carolina':
      return 'sc';
    case 'south-dakota':
      return 'sd';
    case 'tennessee':
      return 'tn';
    case 'texas':
      return 'tx';
    case 'utah':
      return 'ut';
    case 'vermont':
      return 'vt';
    case 'virginia':
      return 'va';
    case 'washington':
      return 'wa';
    case 'west-virginia':
      return 'wv';
    case 'wisconsin':
      return 'wi';
    case 'wyoming':
      return 'wy';
    default:
      return null;
  }
};

export const getFullState = (abbreviatedState) => {
  switch ((abbreviatedState || '').toLowerCase()) {
    case 'al':
      return 'Alabama';
    case 'ak':
      return 'Alaska';
    case 'az':
      return 'Arizona';
    case 'ar':
      return 'Arkansas';
    case 'ca':
      return 'California';
    case 'co':
      return 'Colorado';
    case 'ct':
      return 'Connecticut';
    case 'de':
      return 'Delaware';
    case 'fl':
      return 'Florida';
    case 'ga':
      return 'Georgia';
    case 'hi':
      return 'Hawaii';
    case 'id':
      return 'Idaho';
    case 'il':
      return 'Illinois';
    case 'in':
      return 'Indiana';
    case 'ia':
      return 'Iowa';
    case 'ks':
      return 'Kansas';
    case 'ky':
      return 'Kentucky';
    case 'la':
      return 'Louisiana';
    case 'me':
      return 'Maine';
    case 'md':
      return 'Maryland';
    case 'ma':
      return 'Massachusetts';
    case 'mi':
      return 'Michigan';
    case 'mn':
      return 'Minnesota';
    case 'ms':
      return 'Mississippi';
    case 'mo':
      return 'Missouri';
    case 'mt':
      return 'Montana';
    case 'ne':
      return 'Nebraska';
    case 'nv':
      return 'Nevada';
    case 'nh':
      return 'New Hampshire';
    case 'nj':
      return 'New Jersey';
    case 'nm':
      return 'New Mexico';
    case 'ny':
      return 'New York';
    case 'nc':
      return 'North Carolina';
    case 'nd':
      return 'North Dakota';
    case 'oh':
      return 'Ohio';
    case 'ok':
      return 'Oklahoma';
    case 'or':
      return 'Oregon';
    case 'pa':
      return 'Pennsylvania';
    case 'ri':
      return 'Rhode Island';
    case 'sc':
      return 'South Carolina';
    case 'sd':
      return 'South Dakota';
    case 'tn':
      return 'Tennessee';
    case 'tx':
      return 'Texas';
    case 'ut':
      return 'Utah';
    case 'vt':
      return 'Vermont';
    case 'va':
      return 'Virginia';
    case 'wa':
      return 'Washington';
    case 'wv':
      return 'West virginia';
    case 'wi':
      return 'Wisconsin';
    case 'wy':
      return 'Wyoming';
    default:
      return '';
  }
};

export const getStateSlug = (abbreviatedState) => {
  switch ((abbreviatedState || '').toLowerCase()) {
    case 'al':
      return 'alabama';
    case 'ak':
      return 'alaska';
    case 'az':
      return 'arizona';
    case 'ar':
      return 'arkansas';
    case 'ca':
      return 'california';
    case 'co':
      return 'colorado';
    case 'ct':
      return 'connecticut';
    case 'de':
      return 'delaware';
    case 'fl':
      return 'florida';
    case 'ga':
      return 'georgia';
    case 'hi':
      return 'hawaii';
    case 'id':
      return 'idaho';
    case 'il':
      return 'illinois';
    case 'in':
      return 'indiana';
    case 'ia':
      return 'iowa';
    case 'ks':
      return 'kansas';
    case 'ky':
      return 'kentucky';
    case 'la':
      return 'louisiana';
    case 'me':
      return 'maine';
    case 'md':
      return 'maryland';
    case 'ma':
      return 'massachusetts';
    case 'mi':
      return 'michigan';
    case 'mn':
      return 'minnesota';
    case 'ms':
      return 'mississippi';
    case 'mo':
      return 'missouri';
    case 'mt':
      return 'montana';
    case 'ne':
      return 'nebraska';
    case 'nv':
      return 'nevada';
    case 'nh':
      return 'new-hampshire';
    case 'nj':
      return 'new-jersey';
    case 'nm':
      return 'new-mexico';
    case 'ny':
      return 'new-york';
    case 'nc':
      return 'north-carolina';
    case 'nd':
      return 'north-dakota';
    case 'oh':
      return 'ohio';
    case 'ok':
      return 'oklahoma';
    case 'or':
      return 'oregon';
    case 'pa':
      return 'pennsylvania';
    case 'ri':
      return 'rhode-island';
    case 'sc':
      return 'south-carolina';
    case 'sd':
      return 'south-dakota';
    case 'tn':
      return 'tennessee';
    case 'tx':
      return 'texas';
    case 'ut':
      return 'utah';
    case 'vt':
      return 'vermont';
    case 'va':
      return 'virginia';
    case 'wa':
      return 'washington';
    case 'wv':
      return 'west-virginia';
    case 'wi':
      return 'wisconsin';
    case 'wy':
      return 'wyoming';
    default:
      return '';
  }
};

// A list of state names for display in a drop down and their 2 character state abbreviation value.
// It is used in the CCPA legal form, but placed here in case they need to be used elsewhere.
export const stateItems = [
  { value: 'al', text: 'Alabama' },
  { value: 'ak', text: 'Alaska' },
  { value: 'az', text: 'Arizona' },
  { value: 'ar', text: 'Arkansas' },
  { value: 'ca', text: 'California' },
  { value: 'co', text: 'Colorado' },
  { value: 'ct', text: 'Connecticut' },
  { value: 'de', text: 'Delaware' },
  { value: 'fl', text: 'Florida' },
  { value: 'ga', text: 'Georgia' },
  { value: 'hi', text: 'Hawaii' },
  { value: 'id', text: 'Idaho' },
  { value: 'il', text: 'Illinois' },
  { value: 'in', text: 'Indiana' },
  { value: 'ia', text: 'Iowa' },
  { value: 'ks', text: 'Kansas' },
  { value: 'ky', text: 'Kentucky' },
  { value: 'la', text: 'Louisiana' },
  { value: 'me', text: 'Maine' },
  { value: 'md', text: 'Maryland' },
  { value: 'ma', text: 'Massachusetts' },
  { value: 'mi', text: 'Michigan' },
  { value: 'mn', text: 'Minnesota' },
  { value: 'ms', text: 'Mississippi' },
  { value: 'mo', text: 'Missouri' },
  { value: 'mt', text: 'Montana' },
  { value: 'ne', text: 'Nebraska' },
  { value: 'nv', text: 'Nevada' },
  { value: 'nh', text: 'New Hampshire' },
  { value: 'nj', text: 'New Jersey' },
  { value: 'nm', text: 'New Mexico' },
  { value: 'ny', text: 'New York' },
  { value: 'nc', text: 'North Carolina' },
  { value: 'nd', text: 'North Dakota' },
  { value: 'oh', text: 'Ohio' },
  { value: 'ok', text: 'Oklahoma' },
  { value: 'or', text: 'Oregon' },
  { value: 'pa', text: 'Pennsylvania' },
  { value: 'ri', text: 'Rhode Island' },
  { value: 'sc', text: 'South Carolina' },
  { value: 'sd', text: 'South Dakota' },
  { value: 'tn', text: 'Tennessee' },
  { value: 'tx', text: 'Texas' },
  { value: 'ut', text: 'Utah' },
  { value: 'vt', text: 'Vermont' },
  { value: 'va', text: 'Virginia' },
  { value: 'wa', text: 'Washington' },
  { value: 'wv', text: 'West Virginia' },
  { value: 'wi', text: 'Wisconsin' },
  { value: 'wy', text: 'Wyoming' },
];
